import { defineMessages } from 'react-intl-next';

import { expValEquals } from '@confluence/feature-experiments';

import type { CustomField } from '@atlaskit/editor-common/extensions';

import type { FieldTransformer } from './fieldTypes';

const i18n = defineMessages({
	contentIncludeFieldLabel: {
		id: 'fabric-extension-lib.field-mappings.include.field.contentInclude.label',
		description:
			'New label for the "Page to Include" field in the Include Content macro configuration panel, accounts for all content types instead of just pages',
		defaultMessage: 'Content to include',
	},
});

export const include: FieldTransformer<any> = {
	transformFields: async ({ fields, intl, isLivePagesFeatureEnabled }) => {
		return fields.map((field) => {
			if (field.name !== 'defaultParameterValue') {
				return field;
			}

			return {
				...field,
				type: 'custom',
				label: isLivePagesFeatureEnabled
					? intl.formatMessage(i18n.contentIncludeFieldLabel)
					: field.label,
				// description talks about entering page using SPACEKEY:Page_title syntax
				// which no longer applies as users are now just picking from a dropdown
				description: undefined,
				...(!expValEquals('confluence_include_page_macro_config_bugfix', 'isEnabled', true) && {
					options: {
						resolver: {
							type: 'spaceKeyAndPageTitleContent',
						},
					},
				}),
			} as CustomField;
		});
	},
};
